// 工具函数：@/utils/roleFilter.js（复用逻辑）
/**
 * 过滤超级管理员角色
 * @param {Array} roles 原始角色列表（每个角色需包含id字段）
 * @param {Number} currentUserId 当前登录用户ID
 * @returns 过滤后的角色列表
 */
export function filterSuperAdminRole(roles, currentUserId) {
  // 仅当当前用户不是超级管理员（ID≠1）时，过滤掉角色ID=1的超级管理员
  if (currentUserId !== 1) {
    return roles.filter(role => role.id !== 1);
  }
  // 超级管理员（ID=1）可见所有角色
  return roles;
}